/**
 * Tailwind CSS breakpoint values
 * @see https://tailwindcss.com/docs/breakpoints
 */
export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  XXL: 1536,
} as const;

/**
 * Media query strings for use with useMediaQuery hook
 * Follows Tailwind CSS naming convention
 */
export const MEDIA_QUERIES = {
  // Max-width queries (below breakpoint)
  maxSm: `(max-width: ${BREAKPOINTS.SM - 1}px)`,
  maxMd: `(max-width: ${BREAKPOINTS.MD - 1}px)`,
  maxLg: `(max-width: ${BREAKPOINTS.LG - 1}px)`,
  maxXl: `(max-width: ${BREAKPOINTS.XL - 1}px)`,

  // Min-width queries (at breakpoint and above)
  isSm: `(min-width: ${BREAKPOINTS.SM}px)`,
  isMd: `(min-width: ${BREAKPOINTS.MD}px)`,
  isLg: `(min-width: ${BREAKPOINTS.LG}px)`,
  isXl: `(min-width: ${BREAKPOINTS.XL}px)`,
  is2Xl: `(min-width: ${BREAKPOINTS.XXL}px)`,

  // Height queries
  minH1000: "(min-height: 1000px)",
} as const;
